import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useMemo, useLayoutEffect } from 'react';
import { createGlobalState, useMount, useUnmount } from 'react-use';

var useModalIds = createGlobalState([]);
var sameStyles = function sameStyles(values1, values2) {
  if (!values1 && !values2) {
    return true;
  }
  if (!values1 || !values2) {
    return false;
  }
  return values1.overflowY === values2.overflowY;
};
var newStyles = {
  overflowY: 'hidden'
};

/**
 * Removes the scrollbar of the body while a fodal/modal is openned.
 * @param div wrapper div of the modal or fodal.
 */
function useModalOrchestration(div, modalId) {
  //When this current modal/fodal is mounted, we need to give it an ID that will be in the global state.
  var _useState = useState(function () {
      return modalId !== null && modalId !== void 0 ? modalId : new Date().getTime().toString();
    }),
    _useState2 = _slicedToArray(_useState, 1),
    uid = _useState2[0];

  //Global state of all the modals/fodals in the page currently.
  var _useModalIds = useModalIds(),
    _useModalIds2 = _slicedToArray(_useModalIds, 2),
    ids = _useModalIds2[0],
    setIds = _useModalIds2[1];

  //When the current modal/fodal is mounted, we need to register its ID into the global state.
  useMount(function () {
    return setIds(function (ids) {
      return [].concat(_toConsumableArray(ids), [uid]);
    });
  });

  //When the current modal/fodal is unmounted, we need to deregister its ID into the global state.
  useUnmount(function () {
    return setIds(function (ids) {
      return ids.filter(function (id) {
        return id !== uid;
      });
    });
  });

  //Workout if the current modal is the first/bottom one in the list or the last/top one.
  var _useMemo = useMemo(function () {
      var index = ids.indexOf(uid);
      return {
        first: index === 0,
        last: index === ids.length - 1
      };
    }, [ids, uid]),
    first = _useMemo.first,
    last = _useMemo.last;

  //Styles for the main body
  useLayoutEffect(function () {
    var previousStyles = undefined;
    var change = !sameStyles(newStyles, document.body.style);
    if (first && change) {
      previousStyles = {
        overflowY: document.body.style.overflowY
      };
      Object.assign(document.body.style, newStyles);
    }
    return function () {
      if (previousStyles) {
        Object.assign(document.body.style, previousStyles);
      }
    };
  }, [first]);

  //Styles for the modals under the top one
  useLayoutEffect(function () {
    var previousStyles = undefined;
    var change = !sameStyles(newStyles, div === null || div === void 0 ? void 0 : div.style);
    if (!last && div && change) {
      previousStyles = {
        overflowY: div.style.overflowY
      };
      Object.assign(div.style, newStyles);
    }
    return function () {
      if (previousStyles && div) {
        Object.assign(div.style, previousStyles);
      }
    };
  }, [last, div]);
  return {
    first: first,
    last: last,
    uid: uid
  };
}

export { useModalIds, useModalOrchestration };
//# sourceMappingURL=use-modal-orchestration.esm.js.map
